(function (w, d) {
  'use strict';
  if (w.MataunionAds || !w.MataunionAttribution) return;
  var element = d.getElementById('mataunion-ads-config');
  if (!element) return;
  var cfg;
  try { cfg = JSON.parse(element.textContent); } catch (_) { return; }
  var landing = w.MataunionAdsLanding || { search: w.location.search, arrivedAt: Date.now() };
  var core = w.MataunionAttribution, arrivedAt = landing.arrivedAt, parsed = core.parse(landing.search);
  delete w.MataunionAdsLanding;
  var attribution = null, discarded = false, permission = { analytics: false, marketing: false, sharing: false };
  var state = { consent: 'unknown', attribution: 'absent', pixel: 'disabled', log: 'disabled', issues: parsed.issues };
  var pixelOwned = false, pixelLoaded = false, pixelInitialized = false, pixelLoading = false, pixelQueue = [], jobs = new Set(), timers = new Set();
  var page = { origin: w.location.origin, path: /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:account|checkouts|orders)(?:\/|$)/i.test(w.location.pathname) ? '/private' : w.location.pathname };
  function copy(value) { return value ? JSON.parse(JSON.stringify(value)) : null; }
  function allowed() { return cfg.enabled === true && permission.analytics && permission.marketing; }
  function pixelAllowed() { return allowed() && permission.sharing && cfg.pixelEnabled === true && !!cfg.pixelId; }
  function uuid() { return w.crypto.randomUUID(); }
  function clearRecord() {
    attribution = null;
    try { w.localStorage.removeItem(core.storageKey); } catch (_) { /* Storage may be unavailable. */ }
    state.attribution = 'absent';
  }
  function refreshRecord() {
    if (!allowed()) return;
    var stored = null, storageAvailable = true;
    try {
      var raw = w.localStorage.getItem(core.storageKey);
      try { stored = JSON.parse(raw); } catch (_) { w.localStorage.removeItem(core.storageKey); }
      if (stored && (!core.valid(stored, Date.now()) || new URL(stored.first_landing_page).origin !== page.origin)) {
        w.localStorage.removeItem(core.storageKey); stored = null;
      }
    } catch (_) { storageAvailable = false; }
    if (stored && (!core.valid(attribution, Date.now()) || Date.parse(stored.landing_timestamp) <= Date.parse(attribution.landing_timestamp))) attribution = stored;
    if (attribution && !core.valid(attribution, Date.now())) attribution = null;
    if (!attribution && !discarded && parsed.candidate) {
      try { attribution = core.create(parsed.candidate, page.origin + page.path, arrivedAt, Date.now(), cfg.days, uuid()); }
      catch (_) { state.attribution = 'unavailable'; return; }
    }
    if (!attribution || !core.valid(attribution, Date.now())) { attribution = null; state.attribution = 'absent'; return; }
    if (storageAvailable) {
      try { w.localStorage.setItem(core.storageKey, JSON.stringify(attribution)); }
      catch (_) { storageAvailable = false; }
    }
    state.attribution = storageAvailable ? 'persisted' : 'memory_only';
  }
  function debug() {
    var result = Object.assign({}, state, { permissions: copy(permission), attributionRecord: allowed() ? copy(attribution) : null });
    if (result.attributionRecord && result.attributionRecord.oppref) result.attributionRecord.oppref = '[present]';
    return result;
  }
  function note() { if (cfg.debug && w.console) w.console.info('[Mataunion Ads]', debug()); }
  function initializePixel() {
    if (!pixelLoaded || !pixelAllowed()) return;
    w.oaiq('consent', true);
    if (!pixelInitialized) {
      w.oaiq('init', { pixelId: cfg.pixelId, debug: cfg.debug === true });
      pixelInitialized = true;
    }
  }
  function loadPixel() {
    if (!pixelAllowed()) return;
    if (pixelOwned) { initializePixel(); return; }
    // Another app or theme integration must not be initialized or overridden here.
    if (w.oaiq) { state.pixel = 'external_conflict'; return; }
    var q = function () { q.q.push(arguments); }; q.q = []; w.oaiq = q;
    pixelOwned = true; pixelLoading = true; state.pixel = 'loading';
    // Remain denied while loading: consent may be revoked before the SDK arrives.
    w.oaiq('consent', false);
    var script = d.createElement('script'); script.async = true;
    script.src = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
    script.onload = function () {
      pixelLoading = false; pixelLoaded = true; state.pixel = pixelAllowed() ? 'initialized' : 'waiting_consent';
      initializePixel();
      var queued = pixelQueue; pixelQueue = [];
      if (pixelAllowed()) queued.forEach(sendPixel);
      note();
    };
    script.onerror = function () { pixelLoading = false; pixelQueue = []; state.pixel = 'unavailable'; note(); };
    d.head.appendChild(script);
  }
  function sendPixel(event) {
    if (!pixelAllowed() || !pixelOwned) return;
    if (!pixelLoaded) { if (pixelLoading && pixelQueue.length < 20) pixelQueue.push(event); return; }
    w.oaiq('measure', 'custom', { type: 'custom' }, { event_id: event.event_id, custom_event_name: event.event_name });
    state.pixel = 'submitted'; // SDK invocation is not an Event Stream receipt.
  }
  function endpoint() {
    if (!cfg.logEnabled || !cfg.logEndpoint) return null;
    try { var url = new URL(cfg.logEndpoint); return url.protocol === 'https:' && !url.username && !url.password && !url.hash && !url.search ? url.href : null; }
    catch (_) { return null; }
  }
  function cancelLogs() {
    timers.forEach(function (id) { w.clearTimeout(id); }); timers.clear();
    jobs.forEach(function (job) { job.cancelled = true; if (job.controller) job.controller.abort(); }); jobs.clear();
  }
  function sendLog(event) {
    var target = endpoint();
    if (!target) { state.log = cfg.logEnabled ? 'missing_or_invalid_endpoint' : 'disabled'; return; }
    if (!allowed() || jobs.size >= 20) return;
    var body = JSON.stringify(event);
    if (new TextEncoder().encode(body).length > 16384) { state.log = 'payload_too_large'; return; }
    var job = { cancelled: false, controller: null }; jobs.add(job);
    function attempt(number) {
      if (job.cancelled || !allowed()) { jobs.delete(job); return; }
      job.controller = new AbortController(); state.log = 'sending';
      var timeout = w.setTimeout(function () { job.controller.abort(); }, 8000);
      w.fetch(target, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, credentials: 'omit', keepalive: true, signal: job.controller.signal })
        .then(async function (response) {
          if (job.cancelled || !allowed()) return;
          if (response.status === 429 || response.status >= 500) {
            var retry = response.headers.get('Retry-After');
            var delay = retry ? (Number.isFinite(Number(retry)) ? Number(retry) * 1000 : Date.parse(retry) - Date.now()) : 1000 * Math.pow(2, number);
            return retryLater(delay);
          }
          if (!response.ok) { state.log = 'failed'; jobs.delete(job); return; }
          var result = await response.json().catch(function () { return {}; });
          if (job.cancelled || !allowed()) return;
          state.log = response.status !== 202 && result.event_id === event.event_id && ['stored', 'duplicate'].indexOf(result.status) >= 0 ? 'stored' : 'accepted';
          jobs.delete(job);
        }).catch(function () { if (!job.cancelled && allowed()) retryLater(1000 * Math.pow(2, number)); })
        .finally(function () { w.clearTimeout(timeout); note(); });
      function retryLater(delay) {
        if (number >= 2 || job.cancelled || !allowed()) { jobs.delete(job); state.log = 'failed'; return; }
        if (!Number.isFinite(delay) || delay > 30000) { jobs.delete(job); state.log = 'failed'; return; }
        state.log = 'retrying';
        var timer = w.setTimeout(function () { timers.delete(timer); attempt(number + 1); }, Math.max(1000, delay)); timers.add(timer);
      }
    }
    attempt(0);
  }
  function makeEvent(name, context) {
    refreshRecord();
    return { schema_version: 1, site_id: 'mataunion', event_id: uuid(), event_name: name,
      occurred_at: new Date().toISOString(), page: page, attribution: copy(attribution), context: context || {},
      consent: { analytics: permission.analytics, marketing: permission.marketing, sale_of_data: permission.sharing } };
  }
  function dispatch(event, channel) {
    if (!channel || channel === 'pixel') sendPixel(event);
    if (!channel || channel === 'log') sendLog(event);
  }
  function syncConsent() {
    var privacy = w.Shopify && w.Shopify.customerPrivacy, previous = allowed();
    try {
      if (!privacy) throw new Error('privacy API unavailable');
      permission = { analytics: privacy.analyticsProcessingAllowed() === true, marketing: privacy.marketingAllowed() === true, sharing: privacy.saleOfDataAllowed() === true };
      state.consent = allowed() ? 'allowed' : 'blocked';
    } catch (_) { permission = { analytics: false, marketing: false, sharing: false }; state.consent = 'unknown'; }
    if (!allowed()) {
      if (previous || state.consent === 'blocked' || !cfg.enabled) clearRecord();
      if (previous) {
        discarded = true; parsed.candidate = null;
      }
      pixelQueue = []; cancelLogs();
    } else refreshRecord();
    if (pixelOwned) w.oaiq('consent', pixelLoaded && pixelAllowed());
    if (!pixelAllowed()) { pixelQueue = []; state.pixel = !cfg.pixelEnabled ? 'disabled' : !cfg.pixelId ? 'missing_id' : 'waiting_consent'; }
    else loadPixel();
    if (!cfg.logEnabled) state.log = 'disabled';
    else if (!allowed()) state.log = 'waiting_consent';
    else if (!endpoint()) state.log = 'missing_or_invalid_endpoint';
    note();
  }
  w.MataunionAds = {
    getAttribution: function () { if (!allowed()) return null; refreshRecord(); return copy(attribution); },
    debug: debug,
    track: function (name, context) {
      if (!allowed()) return { status: 'blocked' };
      if (['cta_click', 'outbound_amazon_click'].indexOf(name) < 0) return { status: 'unsupported_event' };
      var safe = {};
      ['product_id', 'placement'].forEach(function (key) { if (context && typeof context[key] === 'string' && /^[a-zA-Z0-9_/-]{1,100}$/.test(context[key])) safe[key] = context[key]; });
      try { var event = makeEvent(name, safe); dispatch(event); return { status: 'processed', event_id: event.event_id }; }
      catch (_) { return { status: 'unavailable' }; }
    }
  };
  if (!cfg.enabled) { clearRecord(); state.consent = 'disabled'; return; }
  if (w.Shopify && w.Shopify.designMode) { state.consent = 'theme_editor_disabled'; return; }
  d.addEventListener('visitorConsentCollected', syncConsent);
  w.addEventListener('storage', function (event) {
    if (event.key !== core.storageKey || !allowed()) return;
    if (!event.newValue) { attribution = null; discarded = true; parsed.candidate = null; }
    refreshRecord();
  });
  // Existing links can opt into tracking without changing navigation behavior.
  d.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[data-ads-event]');
    if (link) w.MataunionAds.track(link.dataset.adsEvent, { placement: link.dataset.adsPlacement || '', product_id: link.dataset.adsProductId || '' });
  });
  function start() {
    syncConsent();
    if (w.Shopify && w.Shopify.loadFeatures && !w.Shopify.customerPrivacy) {
      w.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { if (!error) syncConsent(); });
    }
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})(window, document);
